import { getters } from "@/constants/state";

export default {
  [getters.STATS_TIMESLOTS_GETTER]: (state) => state.timeslots,
  [getters.STATS_EMPLOYEES_GETTER]: (state) => state.employees,
};
